import objectToURLSearchParams from '@lib/util/object-to-url-search-params';
import {
    buildApiResult,
    fetchWithTimeout,
    FetchWithTimeoutOptions,
    genericNetworkError,
    handleHttpErrors,
} from './api-util';
import { fetch_timeout_duration } from '@lib/constants/network-constants';

export default async function usioApi(
    method: string,
    path: string = '',
    payload?: {
        query?: Record<string, any>;
        body?: Record<string, any>;
    },
    access_token?: string,
    header_username?: string
) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${access_token}`);
    if (method === 'GET') {
        if (header_username)
            headers.append(
                'akimbo-impersonate-as-username',
                header_username || ''
            );
    } else {
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
    }

    const options: RequestInit = {
        method,
        headers: headers,
        cache: 'no-store',
    };

    if (payload?.body) {
        options.body = objectToURLSearchParams(payload.body);
    }

    if (payload?.query) {
        const params = objectToURLSearchParams(payload.query).toString();
        path = `${path}?${params}`;
    }

    try {
        const rootUrl = process.env.NEXT_PUBLIC_USIO_APP_URL
            ? process.env.NEXT_PUBLIC_USIO_APP_URL
            : 'https://app.akimbocard.com/api/v2';

        const fetchWithTimeoutOptions: FetchWithTimeoutOptions = {
            timeout: fetch_timeout_duration,
            ...options,
        };

        const response = await fetchWithTimeout(
            `${rootUrl}${path}`,
            fetchWithTimeoutOptions
        );

        if (!response?.ok) {
            try {
                await handleHttpErrors(response);
            } catch (error) {}
        }

        try {
            const body = await response?.json();
            return buildApiResult(response, body);
        } catch (ex) {
            console.error('Failed to parse JSON response:', ex);
            throw new Error(`Failed to parse JSON response`);
        }
    } catch (error: any) {
        throw genericNetworkError;
    }
}
